module.exports = __webpack_public_path__ + "static/media/REMAN-SLIDE-2.a6b090ea.png";